/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { HubeeListeContainer } from '@mairistem/administres-utils';
import { Dimmer, Loader } from '@mairistem/composants';

import { baseUrlApp, getHubeeTeledossiers } from '@/routes';
import { useFetchHubeeStatus } from '@/hooks';
import { useHubeeStore } from '@/zustand';
import HubeeStatusMessage from '../HubeeStatusMessage';

const ListeHubee = () => {
  const hubeeStatus = useHubeeStore((state) => state.hubeeStatus);
  const { fetchHubeeStatus } = useFetchHubeeStatus();

  // Statut relu à chaque ouverture : la liaison a pu être modifiée depuis
  // Paramètres > HubEE.
  React.useEffect(() => {
    fetchHubeeStatus();
  }, [fetchHubeeStatus]);

  // La liste n'est montée qu'une fois le statut connu : désactivée, elle
  // remplace son chargement par un stub et ne se rechargerait pas ensuite.
  if (!hubeeStatus) {
    return (
      <Loader active inline="centered">
        Chargement des demandes en ligne...
      </Loader>
    );
  }

  return (
    <div style={{ position: 'relative', height: '100%' }}>
      <HubeeListeContainer
        urlService={getHubeeTeledossiers()}
        urlDetail={`${baseUrlApp}hubee`}
        urlTraitement={`${baseUrlApp}assistant`}
        activated={!!hubeeStatus?.serialized && !!hubeeStatus?.liaisonActive}
        demarche="PACS"
      />
      {hubeeStatus &&
        (!hubeeStatus.serialized || !hubeeStatus.liaisonActive) && (
          <Dimmer active inverted>
            <div style={{ textAlign: 'center' }}>
              <HubeeStatusMessage
                serialized={hubeeStatus.serialized}
                liaisonActive={hubeeStatus.liaisonActive}
              />
            </div>
          </Dimmer>
        )}
    </div>
  );
};

export default ListeHubee;
